import { render, staticRenderFns } from "./input-checkbox-cmp-extended.vue?vue&type=template&id=7c0d4be8&scoped=true"
import script from "./input-checkbox-cmp-extended.vue?vue&type=script&lang=js"
export * from "./input-checkbox-cmp-extended.vue?vue&type=script&lang=js"
import style0 from "./input-checkbox-cmp-extended.vue?vue&type=style&index=0&id=7c0d4be8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c0d4be8",
  null
  
)

export default component.exports